import { DeviceType } from '../../types';

const SET_DEVICE_TYPE = 'SET_DEVICE_TYPE';
type SET_DEVICE_TYPE = typeof SET_DEVICE_TYPE;

export interface ISetDeviceType {
    type: SET_DEVICE_TYPE;
    payload: DeviceType;
}

export function setDeviceType(payload: DeviceType): ISetDeviceType {
    return {
        type: SET_DEVICE_TYPE,
        payload,
    };
}
